import Projects from "../../components/Project/Projects";

export default function SellerProjects() {
  return (
    <Projects userRole={"Seller"} />
  );
}
